import {
  createAsyncThunk,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import VendorService from "@/services/api/vendor";
import type { Vendor, VendorsResponse } from "@/types/vendortypes";

// Define Vendor type (update according to your API response)

// Define state type
interface VendorState {
  totalVendors: number;
  vendors: Vendor[];
  isFetching: boolean;
}

// Initial state
const initialState: VendorState = {
  totalVendors: 0,
  vendors: [],
  isFetching: false,
};

// Params type for getVendors (customize based on your API query)
type GetVendorsParams = Record<string, any>;

// Async thunk
export const getVendors = createAsyncThunk<
  VendorsResponse, // ✅ return type
  GetVendorsParams, // ✅ argument type
  { rejectValue: string } // ✅ reject type
>("vendor/getVendors", async (params, { rejectWithValue }) => {
  try {
    const data = await VendorService.getVendors(params);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch vendors");
  }
});

// Slice
const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVendors.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(
        getVendors.fulfilled,
        (state, action: PayloadAction<VendorsResponse>) => {
          state.isFetching = false;
          state.vendors = action.payload.rows;
          state.totalVendors = action.payload.count;
        }
      )
      .addCase(getVendors.rejected, (state, action) => {
        state.isFetching = false;
        console.error("Failed to fetch vendors:", action.payload);
      });
  },
});

export default vendorSlice.reducer;
export const { clear } = vendorSlice.actions;

export type { VendorState };
